// extracted by mini-css-extract-plugin
module.exports = {"content":"MemoryNotFound_content__t2jF5","button":"MemoryNotFound_button__So_c_"};